//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import request from '@/api/request';
import formCreate from '@form-create/element-ui';
export default {
  name: 'FollowRules',
  props: {
    ruleForm: {
      default: function _default() {},
      type: Object
    },
    fromData: {
      default: function _default() {},
      type: Object
    }
  },
  components: {
    formCreate: formCreate.$form()
  },
  data: function data() {
    return {
      grid1: {
        xl: 2,
        lg: 4,
        md: 2,
        sm: 24,
        xs: 24
      },
      grid2: {
        xl: 20,
        lg: 18,
        md: 20,
        sm: 24,
        xs: 24
      },
      rules: {}
    };
  },
  methods: {
    onSubmit: function onSubmit(formData) {
      request[this.fromData.method.toLowerCase()](this.fromData.action, formData);
    }
  }
};